import { render, staticRenderFns } from "./deleteMaintainanceItem.vue?vue&type=template&id=b0b8862e&scoped=true"
import script from "./deleteMaintainanceItem.vue?vue&type=script&lang=js"
export * from "./deleteMaintainanceItem.vue?vue&type=script&lang=js"
import style0 from "./deleteMaintainanceItem.vue?vue&type=style&index=0&id=b0b8862e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b8862e",
  null
  
)

export default component.exports